import { useTranslation } from 'react-i18next';
import { Pill } from '../PillGroup.js';
import type { ProjectClientEvent } from '../../hooks/useProjectOutreach.js';

interface ClientEventCardProps {
  event: ProjectClientEvent;
}

// Read-only log line for a client-side action recorded outside of email
// (e.g. submitting the public brief form). No reply/compose actions — it's
// a fact, not a message.
export function ClientEventCard({ event }: ClientEventCardProps) {
  const { t } = useTranslation();
  const label = t(`projects.outreach.clientEvent.${event.stage}`, {
    defaultValue: t('projects.outreach.clientEvent.generic'),
  });

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--evo-space-3)',
      padding: 'var(--evo-space-3) var(--evo-space-4)',
      border: '1px solid var(--evo-stroke)',
      borderRadius: 'var(--evo-r-md)',
    }}>
      <Pill variant="outline" tone="cyan" size="sm">
        {t('projects.outreach.clientEvent.badge')}
      </Pill>
      <span style={{ fontSize: 'var(--evo-fs-body)', color: 'var(--evo-fg-1)', fontFamily: 'var(--evo-font)', flex: 1 }}>
        {label}
      </span>
      <span style={{ fontSize: 'var(--evo-fs-xs)', color: 'var(--evo-fg-3)', fontFamily: 'var(--evo-font)' }}>
        {new Date(event.respondedAt).toLocaleString()}
      </span>
    </div>
  );
}
